import type { IncomingMessage, ServerResponse } from 'http';

import { ACCESS_TOKEN_COOKIE } from '@r1-frontend/shared/constants';
import Cookies from '@r1-frontend/shared/helpers/Cookies';

export const getAuthDataFromCookies = (ctx?: { req?: IncomingMessage, res?: ServerResponse }) => {
    const cookies = new Cookies(ctx);
    const cookieAccessToken = cookies.get(ACCESS_TOKEN_COOKIE);
    return {
        isAuth: !!cookieAccessToken,
        accessToken: cookieAccessToken ?? '',
    };
};
